import { useEffect, useState } from 'react'

// Gleiche Grenze wie der Breakpoint in index.css
const DESKTOP_QUERY = '(min-width: 769px)'

/** true, sobald der Viewport breit genug für zweispaltige Ansichten ist. */
export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
  )

  useEffect(() => {
    const media = window.matchMedia(DESKTOP_QUERY)
    const onChange = (event: MediaQueryListEvent) => setIsDesktop(event.matches)
    setIsDesktop(media.matches)
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return isDesktop
}
